export default __webpack_public_path__ + "static/media/Countdown_4.590c4252.png";